import { useRouteLocations } from '@lp/features/RoutePlanner/hooks/useRouteLocations';
import { ConvertedRouteType } from '@lp/features/RoutePlanner/hooks/useConvertedRoute';
import { useRouteResources } from '@lp/features/RoutePlanner/hooks/useRouteResources';
import { RouteProvider } from '@lp/core/contexts/RouteContext';
import { AircraftUtilizationProvider } from '@lp/features/RoutePlanner/contexts/AircraftUtilizationContext';
import { RouteTypeEnum } from '@/api/apis/route';
import { DataCacheType } from '@/queries/consts';
import { SegmentsList } from './SegmentsList';

export const CurrentRouteList = ({
  segments,
  legs,
  accommodationLegs,
}: Pick<ConvertedRouteType, 'segments' | 'legs' | 'accommodationLegs'>) => {
  const { list } = useRouteLocations(DataCacheType.Snapshot);
  const routeResources = useRouteResources(DataCacheType.Snapshot);

  return (
    <RouteProvider locations={list} resources={routeResources}>
      <AircraftUtilizationProvider>
        <div className="flex flex-col flex-1/2 gap-4 overflow-y-auto bg-base-90 p-4 border-r-1 border-base-70 rounded-l-lg">
          <span className="text-l-cps text-base-30">CURRENT</span>
          <SegmentsList
            routeType={RouteTypeEnum.Main}
            segments={segments}
            legs={legs}
            accommodationLegs={accommodationLegs}
          />
        </div>
      </AircraftUtilizationProvider>
    </RouteProvider>
  );
};
